import { Element } from '@zmedia/bm-soccer-ui/components';
import { memo } from 'react';
import { Avatar } from '@zmedia/bm-soccer-ui/modules/shared/components/avatar';
import { ICoach } from '@zmedia/bm-soccer-ui/interface';
import styles from './style.module.scss';

interface IProps {
    home: ICoach;
    away: ICoach;
}
export function Coach({ home, away }: IProps) {
    return (
        <Element className={styles['coach-container']}>
            <Element className={styles['coach-item']}>
                {home && (
                    <>
                        <Avatar avatar={home.avatar} name={home.name} />
                        <Element className={styles['coach-text']}>
                            {home.name}
                        </Element>
                    </>
                )}
            </Element>
            {home?.name || away?.name ? (
                <Element className={styles['text']}>HLV</Element>
            ) : (
                <Element className={styles['text']}>
                    Chưa có thông tin HLV
                </Element>
            )}
            <Element className={styles['coach-item']}>
                {away && (
                    <>
                        <Avatar avatar={away.avatar} name={away.name} />
                        <Element className={styles['coach-text']}>
                            {away.name}
                        </Element>
                    </>
                )}
            </Element>
        </Element>
    );
}

export default memo(Coach);
